<template>
    <div>
        <h1 class="h5">Je IJSTIJD! code is verzilverd!</h1>
        <h2 class="h3">Het toegangsticket voor de activiteit is naar jouw e-mailadres en die van je ouder/verzorger verstuurd. Veel plezier!</h2>

        <hr>

        <figure class="redeem__image">
            <img
                class="header-home__logo"
                src="@/assets/img/content/guy_skating.png"
                alt="ijstijd">
        </figure>

        <div class="btn-holder btn-holder--center">
            <router-link
                to="/"
                class="btn">
                Terug naar aanbod
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    created() {
        this.logout();
    },
    methods: {
        ...mapActions({
            'logout': 'sportid/logout'
        }),
    }
};
</script>
